import React from 'react';
import { MdClose } from 'react-icons/md';
import { MonitorUp } from 'lucide-react';
import useScrollLock from '../../../hooks/useScrollLock';

interface ScreenShareModalProps {
    isOpen: boolean;
    onClose: () => void;
    onStartShare: () => void;
}

const ScreenShareModal: React.FC<ScreenShareModalProps> = ({ isOpen, onClose, onStartShare }) => {
    useScrollLock(isOpen);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-[#FFF8F0] rounded-2xl p-6 sm:p-8 max-w-lg w-full border border-gray-200/60 shadow-xl">
                <div className="flex justify-between items-center mb-6">
                    <div className="flex items-center gap-3">
                        <MonitorUp className="w-6 h-6 text-orange-600" />
                        <h3 className="text-2xl font-medium text-gray-900">Share Screen</h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl transition-colors"
                    >
                        <MdClose />
                    </button>
                </div>

                <div className="space-y-6">
                    <p className="text-gray-600 text-sm">
                        Are you ready to share your screen with the team? Your browser will prompt you to choose which window or tab to share.
                    </p>

                    <div className="flex gap-3 pt-2">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-3 bg-white border border-gray-200 hover:border-gray-300 text-gray-700 rounded-xl font-medium transition-all duration-300 text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                onStartShare();
                                onClose();
                            }}
                            className="flex-1 px-4 py-3 rounded-xl font-medium transition-all duration-300 text-sm bg-orange-600 hover:bg-orange-700 text-white shadow-sm"
                        >
                            Start Sharing
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScreenShareModal;
